import api from './api';

export interface LibraryImageDetail {
  id: number;
  title: string;
  thumbnail_url: string | null;
  image_file_url: string | null;
}

export interface Quiz {
  id: number;
  chapitre: string;
  question: string;
  reponse: string;
  format: 'txt' | 'tex';
  reponse_format: 'txt' | 'tex';
  is_public: boolean;
  is_deleted: boolean;
  tags: string[];
  created_by: number;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  can_edit: boolean;
  order: number;
  container: number | null;
  /** Sat : savoir-faire mobilisés (lecture) et ids à écrire */
  skills?: { id: number; name: string }[];
  skill_ids?: number[];
  library_images: number[];
  library_images_details: LibraryImageDetail[];
}

class QuizService {
  async getAll(params?: any): Promise<Quiz[]> {
    const response = await api.get('/quizzes/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getQuiz(id: number): Promise<Quiz> {
    const response = await api.get(`/quizzes/${id}/`);
    return response.data;
  }

  async create(data: Partial<Quiz>): Promise<Quiz> {
    const response = await api.post('/quizzes/', data);
    return response.data;
  }

  async update(id: number, data: Partial<Quiz>): Promise<Quiz> {
    const response = await api.patch(`/quizzes/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/quizzes/${id}/`);
  }

  async duplicate(id: number): Promise<Quiz> {
    const response = await api.post(`/quizzes/${id}/duplicate/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/quizzes/reorder/', { items });
  }

  async getAvailableQuizzes(): Promise<Quiz[]> {
    const response = await api.get('/quizzes/available/');
    return response.data;
  }

  async addLibraryImage(quizId: number, imageId: number): Promise<Quiz> {
    const response = await api.post(`/quizzes/${quizId}/add_library_image/`, { image_id: imageId });
    return response.data.quiz;
  }

  async removeLibraryImage(quizId: number, imageId: number): Promise<Quiz> {
    const response = await api.post(`/quizzes/${quizId}/remove_library_image/`, { image_id: imageId });
    return response.data.quiz;
  }
}

const quizService = new QuizService();
export default quizService;
